export default __webpack_public_path__ + "static/media/twitch.0c3788d2.svg";